import styled from "styled-components";

export const StyledCLList = styled.div`
    overflow-y: auto;
    border: none;
    border-radius: 0;
    margin-top: 60px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
